<template>
    <div class="privacy-agreement-page">
        <app-header></app-header>
        <div class="privacy-agreement">
            <h2 class="privacy-agreement__title">好分数辅导隐私政策</h2>
            <div class="privacy-agreement__header">
                <span class="privacy-agreement__time">版本更新日期: 2021年6月9日</span>
                <span class="privacy-agreement__time">本政策生效日期: 2021年6月9日</span>
            </div>
            <p class="artical-preface">
                好分数辅导(以下简称“我们”)深知个人信息对用户的重要性，好分数辅导将按照法律法规等的要求，采取相应安全保护措施，尽力保护用户(以下简称“您”)的个人信息安全可控。
            </p>
            <p >
                【特别提示】请仔细阅读《好分数辅导隐私政策》（尤其是加粗划线的内容）并确定了解我们对您个人信息的处理规则。
                <span class="text-style">阅读过程中，如您有任何疑问，可联系我们的客服咨询，如果您不同意相关协议或其中任何条款约定，好分数辅导将暂时无法为您提供个性化服务。</span>
            </p>
            <p>尊敬的用户：</p>
            <p>
                好分数辅导是由至远无限教育科技（北京）有限公司（以下简称“公司”）运营的在线教育增值服务平台。本隐私政策与您所使用的好分数辅导服务以及该服务所包括的各种业务功能（以下统称“我们的产品与/或服务”）息息相关，希望您在使用我们的产品与/或服务前仔细阅读并确认您已经充分理解本政策所写明的内容，并让您可以按照本隐私政策的指引做出您认为适当的选择。本隐私政策中涉及的相关术语，我们尽量以简明扼要的表述，并提供进一步说明的链接，以便您更好地理解。
                <span class="text-style">您使用或在我们更新本隐私政策后（我们会及时提示您更新的情况）继续使用我们的产品与/或服务，即意味着您同意本隐私政策(含更新版本)内容，并且同意我们按照本隐私政策收集、使用、保存和共享您的相关信息。</span>
                如对本隐私政策或相关事宜有任何问题，您可随时通过发送邮件至marketing@aiyunxiao.com或拨打我们的任何一部客服电话等多种方式与我们联系。
            </p>
            <b>一、个人信息定义及范围</b>
            <p>
                <span class="text-style">1、个人信息：</span>指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。
            </p>
            <p>
                <span class="text-style">2.个人敏感信息：</span>是指一旦泄露、非法提供或滥用可能危人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息。
                <span class="text-style">包括身份证件号码、手机号码、个人生物识别信息、银行账户、财产信息、行踪轨迹、交易信息、14岁以下（含）儿童的个人信息等。</span>
            </p>
            <b>二、我们如何收集和使用您的个人信息</b>
            <p>
                为了向您提供课程服务，我们将根据您使用的服务收集您的如下信息:
            </p>
            <p>
                1、成为好分数辅导用户
            </p>
            <p>
                在使用好分数辅导的部分服务前，您需要先成为好分数辅导的注册用户，以便我们提供服务。注册时需要提供账号使用的
                <span class="text-style">手机号码</span>
                ，并且您可以自愿选择填写您的
                <span class="text-style">真实姓名、年级、头像</span>
                并设置密码。成为好分数辅导用户后，您可以对个人信息进行修改。在您注销好分数辅导账户后，我们将停止为您提供产品或服务，并根据法律规定删除您的个人信息，或进行匿名处理。使用头像功能时，我们会向您告知我们将收集头像信息的
                <span class="text-style">相机权限、存储权限，</span>
                并获得您的同意。我们向您获取相机权限以帮助您提供您的用户头像照片；我们向您获取存储权限以完成您调整您的用户头像照片。若您认为该信息属于与业务功能有关的非必要或无关的信息，您可以选择不同意我们收取和使用您的该部分信息，如果您选择不同意，则可以选择停止使用好分数辅导的产品或服务。
            </p>
            <p>
            2、为向您提供课程服务，可能需要您开通一些设备权限，例如
            <span class="text-style">通知、相册、相机等访问权限。</span>
            您也可以在设备的设置功能中随时选择关闭部分或者全部权限，从而拒绝好分数辅导收集相应的个人信息。在不同设备中，权限显示方式及关闭方式可能有所不同，具体请参考设备及系统开发方说明或指引。
            </p>
            <p>
                根据您的服务使用情况，我们可能会调用的权限如下：
            </p>
            <p>
                <span class="text-style">（1）储存权限：</span>
                当您使用以下模块的功能时，我们会调用您的储存权限，保障您能顺利实现这些功能：
            </p>
            <p>
                登录页、首页、设置：下载升级
            </p>
            <p>
                答题页面：选择相册、上传答案
            </p>
            <p>
                查看原图：下载原图到本地
            </p>
            <p>
                下载作业页面：下载作业
            </p>
            <p>
                答题页面：截图保存
            </p>
            <p>
                课程回放：下载管理
            </p>
            <p>
                练习概览页面：提交答案
            </p>
            <p>
                练习题主观题页面：上传删除试题
            </p>
            <p>
                在线咨询：选择照片
            </p>
            <p>
                <span class="text-style">（2）录音权限：</span>
                当您选用本产品的在线咨询、上课功能时、我们会调用您的麦克风及录音权限，保障您的学习功能。
            </p>
            <p>
                <span class="text-style">（3）摄像头权限：</span>当您使用以下模块的功能时，我们将调用您的摄像头权限，保障您进行个性化的使用：
            </p>
            <p>
                智能练习、作业本-上传答案
            </p>
            <p>
                <span class="text-style">（4）拨打电话权限：</span>当您需要联系客服，点击拨打客服电话时、在报名辅导课程成功咨询老师时，我们将调用您的拨打电话权限。
            </p>
            <p>
                <span class="text-style">（5）使用网络电话权限：</span>当您在好分数辅导进行在线课程辅导时，辅导过程中如需使用网络电话沟通，我们将调用您的使用网络电话权限。
            </p>
            <p>
                <span class="text-style">（6）修改或查看拨号权限：</span>当您在好分数辅导进行在线课程辅导时，我们将调用您修改或查看拨号权限，以确认当前麦克风是否被占用，保障线上课程的正常进行。
            </p>
            <p>
                <span class="text-style">（7）通知权限：</span>当您升级版本、接收极光push推送、查看推送消息，我们将调用通知权限，保障您能顺利收到通知。
            </p>
            <p>
                <span class="text-style">（8）get_tasks权限:</span>当您使用App时，我们将读取您的应用安装列表，以防止恶意程序，确保安全运营，并在您收到推送时，确保推送功能正常使用。
            </p>
            <p>
                <span class="text-style">（9）悬浮窗权限：</span>当您设置护眼模式、首次点击侧边悬浮图标时，我们将调用您的悬浮窗权限，以保障您可以正常使用相关功能。
            </p>
            <p>
                <span class="text-style">（10）相册权限：</span>当您使用以下模块的功能时，我们会调用您的相册权限，保障您能顺利实现这些功能：
            </p>
            <p>
                答题页面：上传答案
            </p>
            <p>
                答题页面：截图保存
            </p>
            <p>
                查看原图：下载原图到本地
            </p>
            <p>
                练习概览：提交答案
            </p>
            <p>
                练习题主观题页面：上传删除试题
            </p>
            <p>
                在线咨询：选择照片
            </p>
            <p>
                <span class="text-style">（11）读取电话状态权限：</span>当您在好分数辅导进行在线课程时，我们将调用您的读取电话状态权限，以确认您当前设备所处的状态，保障线上课程的正常运行。
            </p>
            <p>
                3、我们通过不断提升的技术手段加强安装在您的设备的软件的安全能力，以防您的个人信息泄露，为了保障向您提供的服务的安全稳定运营，预防病毒、木马程序和其他恶意程序、网站，我们会收集关于您使用产品、服务以及使用方式的信息并将这些信息进行关联，这些信息包括:
            </p>
            <p style="font-weight: bold;">
                (1)设备信息：我们可能会根据您在软件安装及使用中授予的具体权限，接收并记录您所使用的设备相关信息(包括 IMEI、Serial、SIM 卡 IMSI 识别码、设备机型、操作系统及版本、客户端版本、设备分辨率、包名、设备设置、进程及必要的应用列表、唯一设备标识符软硬件特征信息)。
            </p>
            <p style="font-weight: bold;">
                (2)日志信息:当您使用我们的服务时，我们可能会自动收集您对我们服务的详细使用情况，作为有关网络日志保存，用于分析解决崩溃问题。日志信息包括您的登录账号、搜索查询内容、IP 地址、浏览器的类型、电信运营商、网络环境、使用的语言、访问日期和时间、崩溃记录、停留时长。
            </p>
            <p style="font-weight: bold;">
                同时为了收集上述基本的个人设备信息，我们将会申请访问您的设备信息的权限，征求您的同意，我们收集这些信息是为了向您提供我们基本服务和基础功能，如您拒绝提供上述权限将可能导致您无法使用我们的产品与服务。
            </p>
            <p>
                4、例外的情况：
            </p>
            <p>
                4.1以下情形我们可不响应您提出的查询、更正、删除、撤回授权、注销、获取个人信息副本的请求，包括:
            </p>
            <p>
                (1)与好分数辅导履行法律法规规定的义务相关的；
            </p>
            <p>
                (2)与国家安全、国防安全直接相关的；
            </p>
            <p>
                (3)与公共安全、公共卫生、重大公共利益直接相关的；
            </p>
            <p>
                (4)与刑事侦查、起诉、审判和执行判决等直接相关的；
            </p>
            <p>(5)好分数辅导有充分证据表明个人信息主体存在主观恶意或滥用权利的；</p>
            <p>(6)出于维护用户或其他个人的生命、财产等重大合法权益但又很难得到本人授权同意的；</p>
            <p>(7)响应用户的请求将导致用户或其他个人、组织的合法权益受到严重损害的；</p>
            <p>(8)涉及商业机密的。</p>
            <p>4.2 根据相关法律法规规定及国家标准，以下情形中，我们可能会依法共享、转让、公开披露您的个人信息无需征得您的同意：</p>
            <p>
                (1)与好分数辅导履行法律法规规定的义务相关的；
            </p>
            <p>
                (2)与国家安全、国防安全直接相关的；
            </p>
            <p>
                (3)与公共安全、公共卫生、重大公共利益直接相关的；
            </p>
            <p>
                (4)与刑事侦查、起诉、审判和执行判决等直接相关的；
            </p>
            <p>
                (5)出于维护用户或其他个人的生命、财产等重大合法权益但又很难得到本人授权同意的；
            </p>
            <p>
                (6)用户自行向社会公众公开的个人信息；
            </p>
            <p>
                (7)从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。
            </p>
            <p>
                4.3 根据相关法律法规规定及国家标准，以下情形中，我们可能会依法收集、使用您的个人信息无需征得您的同意：
            </p>
            <p>
                (1)与个人信息控制者履行法律法规规定的义务相关的；
            </p>
            <p>
                (2)与国家安全、国防安全直接相关的；
            </p>
            <p>
                (3)与公共安全、公共卫生、重大公共利益直接相关的；
            </p>
            <p>
                (4)与刑事侦查、起诉、审判和判决执行等直接相关的；
            </p>
            <p>
                (5)出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人授权同意的；
            </p>
            <p>
                (6)所涉及的个人信息是个人信息主体自行向社会公众公开的；
            </p>
            <p>
                (7)根据个人信息主体要求签订和履行合同所必需的；
            </p>
            <p>
                (8)从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；
            </p>
            <p>
                (9)维护所提供产品或服务的安全稳定运行所必需的，如发现、处置产品或服务的故障；
            </p>
            <p>
                (10)个人信息控制者为新闻单位，且其开展合法的新闻报道所必需的；
            </p>
            <p>
                (11)个人信息控制者为学术研究机构，出于公共利益开展统计或学术研究所必要，且其对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的。
            </p>
            <b>三、我们如何使用 Cookie 和同类技术</b>
            <p>
            “Cookie”是用作您计算机标识卡的计算机文件。我们或我们的第三方合作伙伴，可能通过cookies收集和使用您的信息(包括:设备唯一标示、APP 版本、登录鉴权 ID、三方统计 ID)，并将该等信息储存为日志信息。我们使用cookies 目的是为识别您的身份，帮您省去重复输入注册信息的步骤，或者帮助判断您的帐号安全状态。我们可能会通过cookies 收集非个人身份信息。如果您的浏览器或浏览器附加服务允许，您可以修改对Cookie的接受程度或者拒绝好分数辅导的 Cookie，请您理解，我们的某些服务只能通过使用Cookie才可得到实现。
            </p>
            <b>四、我们如何共享您的个人信息</b>
            <p>
                您同意我们依据本政策与下列信息接收方共享您的个人信息(合称为“信息接收方”)：我们的关联方或相关法人团体；与我们合作的一些商业合作伙伴。我们可能委托商业合作伙伴为您提供某些服务或者代表我们履行职能(简称“我们信任的商业合作伙伴”)。我们仅会出于合法、正当、必要、特定、明确的目的在有限的程度内与其共享您的个人信息，即我们信任的商业合作伙伴为了提供其受聘所需服务而合理所必需的个人信息。我们信任的商业合作伙伴无权将共享的个人信息用于任何其他用途。
            </p>
            <p>
                目前我们信任的商业合作伙伴包括：服务提供商、供应商和其他合作伙伴。例如帮助我们运营网站，代表我们处理与您的个人信息相关的某些活动并向我们的客户和访客提供重要服务的服务提供商。
            </p>
            <p>
                除以上信息接收方外，在获取您明确同意情况下，我们可能与其他信息接收方共享您的个人信息。对我们与之共享个人信息的信息接收方，我们会与其签署保密条款、要求他们按照我们的说明、本政策及其他任何相关的保密和安全措施来处理您的个人信息。信息接收方对您个人信息仅有有限的访问权，他们还承担契约义务，包括(但不限于)使用符合相关法律规定的方式使用通过我们获得的个人信息或以其他方式代表我们获取的任何个人信息，采取合理的安全 措施(包括适用法律所要求的措施)，并根据适用法律的规定和契约的约定承 担相关的法律责任。
            </p>
            <b>五、我们如何保护您的个人信息</b>
            <p>
                好分数辅导非常重视信息安全，努力使用各种安全技术和程序以防信息的丢失、不当使用、未经授权阅览或披露。在某些服务中，将利用加密技术来保护用户向好分数辅导提供的个人信息。
                <span class="text-style">请您理解，由于技术的限制及风险防范的局限，即使我们尽力加强安全措施，也无法始终保证信息百分之百的安全。您需要了解，用户接入互联网服务所使用的系统和通讯网络，有可能因我们可控范围外的情况而发生问题。</span>
            </p>
            <p>
                1、用户的账户均有安全保护功能，用户应采取积极措施保护个人信息的安全， 包括但不限于使用复杂密码、定期修改密码、不将自己的账号密码等个人信息透漏给他人。
            </p>
            <p>
                2、除非经过用户同意，我们不允许任何用户、第三方通过我们收集、出售或者传播用户信息。
            </p>
            <p>
                3、在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知:安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施。我们同时将及时将事件相关情况以邮件、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。
            </p>
            <b>六、如何管理您的个人信息</b>
            <p>
                我们将尽一切可能采取适当的技术手段，保证收集到的有关于您的个人信息的准确性，并保证及时进行更新。
            </p>
            <p>
                6.1 更正或补充您的个人信息
            </p>
            <p>
                除法律法规规定外，您有权随时访问和更正您的个人信息，具体包括：
            </p>
            <p>
                具体路径为：“我的”进入我的好分数辅导--点击头像可以修改个人信息头像，您也可以通过「我的」-【咨询与反馈】页面，按照好分数辅导的相关政策及提示，或联系在线客服，对您的个人信息进行访问、更正。
            </p>
            <p>
                6.2删除您的个人信息:您可以通过「我的」-【咨询与反馈】页面，按照好分数辅导的相关政策及提示，
                <span class="text-style">联系在线客服或拨打客服电话（400-8180-190），并提供注册使用的手机号，在您核验通过后，将在15个工作日内帮您删除个人信息中的某一项或某几项，并与您反馈。</span>
                如我们停止运营或停止提供相关服务，我们将会及时停止收集您个人信息，并将停止运营的通知以逐一送达或公告的形式通知您，对所持有的个人信息进行删除或匿名化处理。
            </p>
            <p>
            在以下情形中，您可以向我们提出删除个人信息的请求:
            </p>
            <p>
                (1)如果我们处理个人信息的行为违反法律法规;
            </p>
            <p>
                (2)如果我们收集、使用您的个人信息，却未征得您的同意;
            </p>
            <p>
                (3)如果我们处理个人信息的行为严重违反了与您的约定;
            </p>
            <p>
                (4)如果您不再使用我们的产品或服务，或您注销了账号;
            </p>
            <p>
                (5)如果我们不再为您提供产品或服务。
            </p>
            <p>
                若我们决定响应您的删除请求，我们还将同时尽可能通知从我们处获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。
            </p>
            <p>
                6.3撤回授权您的个人信息:部分个人信息是使用我们服务所必需的，但大多数其他个人信息的提供是由您决定的。您可以通过解除绑定、修改个人设置、删除相关信息等方式撤回部分授权，也可以通过“我的-设置-关于好分数辅导-好分数辅导隐私协议”底部的撤销同意授权的方式撤销全部授权。您可以电话联系客服（电话服务渠道：400-8180-190）向我们提出撤回对于隐私政策协议内容的同意授权。
                <span class="text-style">当您撤回同意或授权后，我们无法继续为您提供撤回同意或授权所对应的服务，也将不再处理您相应的个人信息。但您撤回同意或授权的决定，不会影响此前基于您的同意或授权而开展的个人信息处理，我们会在15天内响应、做出答复或合理解释。</span>
            </p>
            <p>
                6.4注销您的账号：您可以在“我的-设置-关于好分数辅导-注销账号”，自行发起账号注销。成功发起自主注销后，您可以实时完成注销。在您注销账号前，为了保护账号资产的安全，我们会进行必要的验证，包括是否有存在剩余课时、学分等，有关注销的流程和具体内容，请参见“关于好分数辅导-注销账号”页面的指引。
                <span class="text-style">需要人工处理的，我们将在15个工作日内完成核查和处理。</span>
                在您成功注销账号后，我们将停止为您提供与账号相关的服务，并将删除有关您账号的一切信息或对相关信息进行匿名化处理，但法律法规另有规定的除外。如您需要操作指引可拨打客服（400-8180-190），客服人员指导您自行操作后，亦可完成注销。在您主动注销帐号之后，我们将根据法律的要求对您的个人信息进行匿名化处理。
            </p>
            <p>
                6.5个人信息主体获取个人信息副本：您有权获取您的个人信息副本，您可以电话联系客服（电话服务渠道：400-8180-190）进行客服处理。
            </p>
            <p>
                在技术可行的前提下，例如数据接口匹配，我们还可按您的要求，直接将您的个人信息副本传输给您指定的第三方。
            </p>
            <p>
                6.6约束信息系统自动决策：在某些业务功能中，我们可能仅依据信息系统、算法在内的非人工自动决策机制做出决定。如果这些决定显著影响您的合法权益，您有权要求我们做出解释，我们也将提供适当的救济方式。
            </p>
            <p>
                6.7响应您的上述请求：为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。我们将在十五天内做出答复。如您不满意，还可以通过我的-资询与反馈进行反馈。对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。
            </p>
            <p>
                对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。在以下情形中，按照法律法规要求，我们将无法响应您的请求：
            </p>
            <p>
                1、与国家安全、国防安全直接相关的；
            </p>
            <p>
                2、与公共安全、公共卫生、重大公共利益直接相关的；
            </p>
            <p>
                3、与犯罪侦查、起诉、审判和判决执行直接相关的；
            </p>
            <p>
                4、有充分证据表明您存在主观恶意或滥用权利的；
            </p>
            <p>
                5、响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；
            </p>
            <p>
                6、涉及商业秘密的。
            </p>
            <b>七、我们使用的第三方 SDK 服务</b>
            <p>
                <span class="text-style">为实现本隐私政策中声明的功能，我们会接入第三方服务商提供的 SDK 或其他类似的应用程序，并将我们依照本隐私政策收集的个人信息共享给第三方服务商，以完善课程服务和用户体验。</span>
                目前，我们接入的第三方服务商主要包括:
            </p>
            <div class="table">
                <ul class="tr list ">
                    <li class="td" style="background:#999">SDK名称</li>
                    <li class="td" style="background:#999">涉及的个人信息</li>
                    <li class="td" style="background:#999">服务用途</li>
                    <li class="td" style="background:#999">SDK相关隐私政策地址</li>
                    <li class="td" style="background:#999">所属公司</li>
                </ul>
                <ul class="tr list">
                    <li class="td">友盟统计U-App/分享U-Share</li>
                    <li class="td">常用设备信息（IMEI/Mac/android ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 信息））、网络连接信息，手机号码，被分享账号的公开信息</li>
                    <li class="td">数据统计分析/向目标设备以及指定社交账号分享消息</li>
                    <li class="td">https://www.umeng.com/page/policy</li>
                    <li class="td">友盟同欣（北京）科技有限公司</li>
                </ul>
                <ul class="tr list">
                    <li class="td">腾讯Bugly</li>
                    <li class="td">常用设备信息（androidid 以及 idfv）、网络连接信息</li>
                    <li class="td">数据统计分析、崩溃收集</li>
                    <li class="td">https://bugly.qq.com/v2/contract</li>
                    <li class="td">深圳市腾讯计算机系统有限公司</li>
                </ul>
                <ul class="tr list">
                    <li class="td">微信支付</li>
                    <li class="td">设备标识信息、微信支付授权信息、Mac地址、IMEI、Android_id、IMSI</li>
                    <li class="td">支付</li>
                    <li class="td">https://pay.weixin.qq.com/index.php/public/apply_sign/protocol_v2</li>
                    <li class="td">财付通支付科技有限公司</li>
                </ul>
                <ul class="tr list">
                    <li class="td">支付宝支付</li>
                    <li class="td">常用设备信息（IMEI/IMSI、SIM卡序列号/MAC地址、android_id）、网络信息</li>
                    <li class="td">支付</li>
                    <li class="td">https://opendocs.alipay.com/apis/01da4m</li>
                    <li class="td">支付宝（中国）网络技术有限公司</li>
                </ul>
                <ul class="tr list">
                    <li class="td">极光推送</li>
                    <li class="td">设备信息[ 设备信息包括：设备标识符（IMEI、IDFA、Android ID、MAC、OAID等相关信息）、应用信息（应用崩溃信息、通知开关状态、软件列表等相关信息）、设备参数及系统信息（设备类型、设备型号、操作系统及硬件相关信息）]、网络信息[ 网络信息包括：IP地址，WiFi信息，基站信息等相关信息 ]</li>
                    <li class="td">消息推送</li>
                    <li class="td">https://www.jiguang.cn/license/privacy</li>
                    <li class="td">深圳市和讯华谷信息技术有限公司</li>
                </ul>
                <ul class="tr list">
                    <li class="td">小米推送</li>
                    <li class="td">常用设备信息（品牌、型号、IMEI、手机号、网络连接、IP、MAC）</li>
                    <li class="td">消息推送</li>
                    <li class="td">https://dev.mi.com/console/doc/detail?pId=1822</li>
                    <li class="td">小米科技有限责任公司</li>
                </ul>
                <ul class="tr list">
                    <li class="td">Vivo推送</li>
                    <li class="td">常用设备信息（品牌、型号、IMEI、手机号、网络连接、IP、MAC）</li>
                    <li class="td">消息推送</li>
                    <li class="td">https://dev.vivo.com.cn/documentCenter/doc/366</li>
                    <li class="td">广东天宸网络科技有限公司</li>
                </ul>
                <ul class="tr list">
                    <li class="td">OPPO推送</li>
                    <li class="td">常用设备信息（品牌、型号、IMEI、手机号、网络连接、IP、MAC）</li>
                    <li class="td">消息推送</li>
                    <li class="td">https://open.oppomobile.com/wiki/doc#id=10288</li>
                    <li class="td">广东欢太科技有限公司</li>
                </ul>
                <ul class="tr list">
                    <li class="td">魅族推送</li>
                    <li class="td">常用设备信息（品牌、型号、IMEI、手机号、网络连接、IP、MAC）</li>
                    <li class="td">消息推送</li>
                    <li class="td">https://i.flyme.cn/privacy</li>
                    <li class="td">珠海市魅族通讯设备有限公司</li>
                </ul>
                <ul class="tr list">
                    <li class="td">容联七陌</li>
                    <li class="td">设备信息（您的设备或 SIM 卡信息与您的设备相关的信息。例如IMEI编号、IMSI编号、IDFA编号、MAC地址、手机号码、App包名、App版本、设备类型、操作系统类型、操作系统版本、设备厂商、设备型号、屏幕宽度及高度、手机运营商、网络连接类型、GPS 信息。）</li>
                    <li class="td">客服咨询</li>
                    <li class="td">http://m.7moor.com/static/m7PrivacyPolicy.html</li>
                    <li class="td">北京容联七陌科技有限公司</li>
                </ul>
                <ul class="tr list">
                    <li class="td">声网SDK</li>
                    <li class="td">与您设备相关的信息（为实现实时音频或视频通话，我们需要您授权开启您的摄像头功能、麦克风功能；我们还会收集您的设备类型、设备型号、CPU信息、储存信息、电池电量信息、操作系统信息）、网络状况相关的信息（IP地址、信号强度信息、网络类型、用户代理、蓝牙开启信息）、产品交互相关的信息、音视频信息（我们将为实现实时音视频互动业务功能收集、传输、录制、储存您在使用服务过程中产生的音频流信息、视频流信息以及文字通讯信息，这些信息可能包括您或者/及与您进行互动的个人向我们提供的您的个人信息（包括您发送的文字、图片、音频、视频、您的图像、声音、肖像以及您交流的内容）</li>
                    <li class="td">课堂音视频互动</li>
                    <li class="td">https://www.agora.io/cn/privacy-policy</li>
                    <li class="td">上海兆言网络科技有限公司</li>
                </ul>
                <ul class="tr list">
                    <li class="td">华为推送</li>
                    <li class="td">设备信息（包括设备名称、设备识别符、设备激活时间、硬件型号、操作系统版本、应用程序版本、软件识别码、设备及应用设置（如地区/语言/时区/字体））、应用安装列表</li>
                    <li class="td">消息推送</li>
                    <li class="td">https://consumer.huawei.com/cn/privacy/privacy-policy/</li>
                    <li class="td">华为技术有限公司</li>
                </ul>
                <ul class="tr list">
                    <li class="td">QQ互联</li>
                    <li class="td">常用设备信息（品牌、型号、IMEI、手机号、IP、MAC）、网络连接信息、被分享账号的公开信息</li>
                    <li class="td">QQ分享</li>
                    <li class="td">https://wiki.connect.qq.com/qq%e4%ba%92%e8%81%94sdk%e9%9a%90%e7%a7%81%e4%bf%9d%e6%8a%a4%e5%a3%b0%e6%98%8e</li>
                    <li class="td">深圳市腾讯计算机系统有限公司</li>
                </ul>
            </div>
            <p class="text-style">
                如上所述服务由相关的第三方负责运营。您使用这些第三方服务(包括您向这些第三方提供的任何个人信息)，须受第三方自己的服务条款及个人信息保护声明(而非本隐私政策)的约束，您需要仔细阅读其条款。我们仅会出于正当、必要、特定的目的共享您的信息。我们会要求他们履行相关保密义务并采 取相应的安全措施。
            </p>
            <b>八、我们会如何保护和保存您的个人信息</b>
            <p>
                好分数辅导重视个人信息的安全。我们采取互联网业内标准做法来保护您的个人信息，防止信息遭到未经授权访问、披露、使用、修改、损坏或丢失。我们会采取一切合理可行的措施，保护您的个人信息。我们会采取一切合理可行的措施，确保未收集与好分数辅导提供的服务无关的个人信息。我们会尽全力保护您的个人信息，但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，不可能始终保证信息百分之百的安全。您需要了解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。我们仅允许有必要知晓这些信息的好分数辅导关联方的员工、合作伙伴访问个人信息，并为此设置了严格的访问权限控制和监控机制。我们同时要求可能接触到您个人信息的所有人员履行相应的保密义务。如果未能履行这些义务，可能会被追究法律责任或被中止与好分数辅导的合作关系。我们同时要求可能接触到您个人信息的所有人员履行相应的保密义务。如果未能履行这些义务，可能会被追究法律责任或被中止与好分数辅导的合作关系。在发生个人信息安全事件的场合，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。我们在中华人民共和国境内收集和产生的个人信息将存储在中华人民共和国境内，
                <span class="text-style">且存储期限满足法律法规要求的最小期限，超出储存期限后将对您的数据进行匿名化处理。</span>
                如果日后为处理跨境业务，需要向境外机构传输境内收集的相关个人信息的，我们会事先征得您的同意，按照法律、行政法规和相关监管部门的规定执行，并通过签订协议、核查等有效措施，要求境外机构为所获得的个人信息保密。我们仅会在达到本政策所述目的所必需的时限内保存您的个人信息，但为了遵守适用的法律法规、法院判决或裁定、其他有权机关的要求、维护公共利益等目的，我们可能会将个人信息保存时间予以适当延长。
            </p>
            <b>
                九、我们如何处理未成年人的个人信息
            </b>
            <p>
                我们非常重视未成年人的信息保护，
                <span class="text-style">如您为未成年人，建议您请您的父母或监护人仔细阅读本隐私权政策，并在征得您的父母或监护人同意的前提下使用我们的服务或向我们提供信息。</span>
                对于经父母或监护人同意使用我们的产品或服务 而收集未成年人个人信息的情况，我们只会在法律法规允许，父母或监护人明确同意或者保护未成年人所必要的情况下收集、使用、共享、转让或公开披露此信息。我们将遵循正当必要、知情同意、目的明确、安全保障、依法利用的原则，根据国家相关法律法规及本政策的规定保护未成年人的个人信息。
                <span class="text-style">如您的监护人不同意本隐私政策，您应立即停止使用好分数辅导的服务并拒绝提供个人信息，需要进行修改或删除处理的，请随时与我们联系。</span>
            </p>
            <p>
                特别地，若你是14周岁以下的儿童，我们还专为你制定了《儿童隐私政策》，儿童及其监护人在为14周岁以下的儿童完成账号注册前，还应仔细阅读我们专门制定的《儿童隐私政策》。《儿童隐私政策》是适用于14周岁以下的儿童用户的信息保护规则，该政策是在《隐私政策》基础上制定的特别规则，如其与本政策有不一致之处，以《儿童隐私政策》为准。
            </p>
            <b>
                十、您的个人信息的跨境转移
            </b>
            <p>
                我们在中华人民共和国境内收集和产生的个人信息将存储在中华人民共和国境内，这意味着，原则上您的个人信息不会被转移到您使用产品或服务所在国家/地区的境外管辖区。
            </p>
            <b>十一、本政策如何更新</b>
            <p>
                我们的隐私政策可能变更。
            </p>
            <p>
                未经您明确同意，我们不会削减您依据当前生效的本政策所应享受的权利。当本政策发生重大变化时，我们将采取弹窗提醒、消息推送、邮件通知等方式及时通知您，构成重大变化的情况包括但不限于：
            </p>
            <p>
                1.我们提供的服务范围、模式等发生重大变化，如收集、使用个人信息的目的、处理个人信息的类型、个人信息的使用方式、接收数据的第三方身份等发生改变；
            </p>
            <p>
                2.我们的经营主体、组织架构、所有权结构等方面发生重大变化，如业务调整、兼并收购重组等引起的所有者变更；
            </p>
            <p>
                3.您参与个人信息处理方面的权利及其行使方式发生重大变化；
            </p>
            <p>
                4.个人信息共享、转让或公开披露的方式、主要对象等发生变化；
            </p>
            <p>
                5.个人信息风险评估报告表明存在高风险时；
            </p>
            <p>
                6.我们负责个人信息安全的责任部门及其联系方式、投诉渠道发生变化；
            </p>
            <p>
                7.其他可能对您的个人信息权益产生重大影响的变化。
            </p>
            <p>
                为了您能及时接收到通知，建议您在联系方式更新时及时通知我们。如您在本政策更新生效后继续使用App服务，即表示您已充分阅读、理解并接受更新后的政策并愿意受更新后的政策约束。
            </p>
            <p>
                您可以在本App通过“我的→设置→关于好分数辅导→隐私政策”中查看本政策。我们鼓励您在每次使用App时都查阅我们的隐私政策。
            </p>
            <p>
                如本政策与特定服务的隐私政策有不一致之处，请以该特定隐私政策为准。
            </p>
            <b>十二、联系我们</b>
            <p>
                如果您有任何个人信息的疑问、意见、建议或投诉举报，您可以在“我的-设置-关于好分数辅导-投诉/举报电话（400-8180-190）”或“我的-设置-关于好分数辅导-投诉/举报邮箱（marketing@aiyunxiao.com）”随时与我们联系 ，我们将在15日内回复您的请求。
            </p>
            <p>
                至远无限教育科技（北京)有限公司
            </p>
            <p>
                注册地址：北京市海淀区学清路甲18号
            </p>
            <p>
                邮箱：marketing@aiyunxiao.com
            </p>
            <p>
                电话：400-8180-190
            </p>
            <b>
                十三、更新说明
            </b>
            <p>
                至远无限教育科技（北京）有限公司保留随时更新本声明的权利，当声明发生修改时，我们会通过通知的方式告知您变更后的声明。如您继续使用我们的服务，即视为您同意我们的变更后的隐私政策我们才会按照更新的声明收集、使用、存储您的个人信息。
            </p>
        </div>
        <app-footer></app-footer>
    </div>
</template>

<script>
import AppHeader from './AppHeader';
import AppFooter from './AppFooter';
export default {
    components: {
        AppHeader,
        AppFooter
    }
};
</script>

<style lang="scss" scoped>
.privacy-agreement {
    background: #fff;
    width: 1200px;
    margin: 20px auto;
    padding: 30px 50px;
    min-height: 800px;

    &__title {
        text-align: center;
        font-family: PingFangSC-Medium;
        font-weight: bold;
        font-size: 18px;
        color: #333333;
        line-height: 25px;
        margin-bottom: 20px;
    }

    &__header {
        font-family: PingFangSC-Medium;
        font-weight: bold;
        font-size: 14px;
        color: #333333;
        letter-spacing: 0;
        line-height: 26px;
        margin-bottom: 13px;
    }

    &__time {
        display: inline-block;
        margin-right: 30px;
    }

    &__sub-title {
        text-align: center;
        font-family: PingFangSC-Medium;
        font-weight: bold;
        font-size: 16px;
        color: #4A4A4A;
        letter-spacing: 0;
        line-height: 20px;
        margin-top: 20px;
        margin-bottom: 10px;
    }

    b {
        font-family: PingFangSC-Medium;
        font-weight: bold;
        font-size: 14px;
        color: #4A4A4A;
        letter-spacing: 0;
        line-height: 20px;
        margin-bottom: 10px;
    }

    p {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #4A4A4A;
        letter-spacing: 0;
        line-height: 20px;
        margin-bottom: 10px;
    }

    .text-style{
        color: #333;
        font-weight: bold;
    }

    .artical-preface {
        margin-bottom: 7px;
        font-size: 13px;
        color: #666;
    }
}
.table{
    box-sizing: border-box;
    display: table;
    border: 1px solid #000;
    width: 100%;
    border-collapse: collapse;
}
.tr{
    display: table-row;
    width: 100%;
}
.td{
    display: table-cell;
    border: 1px solid #000;
    vertical-align: middle;
    text-align: center;
}
.list li{
    width: 20%;
    word-break: break-all;
    padding: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/index/components/PrivacyAgreement.vue